import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import LoaderButton from '../components/LoaderButton';

import styles from './Settings.module.less';

export default class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className={styles.settings}>
        <LinkContainer to="/settings/user-profile">
          <LoaderButton block bsSize="large" text="Change User Profile" />
        </LinkContainer>
        <LinkContainer to="/settings/password">
          <LoaderButton block bsSize="large" text="Change Password" />
        </LinkContainer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings.js